import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { PaymentProfile } from "@iscr/views/admin/docpay/dashboard/PaymentProfile";
import { useGetPaymentProfile } from "@iscr/views/admin/docpay/dashboard/useGetPaymentProfile";
import { Segment } from "semantic-ui-react";
import { useUser } from "../Hooks";
/**
 * Bank details for the logged-in doctor's own profile page - fetches their payment profile
 * and reuses the admin dashboard's PaymentProfile form for viewing/editing it.
 */
export const MyPaymentProfile = () => {
    const user = useUser();
    const docId = user.claims.doc_id;
    const { loading, error, data, fn: refetch } = useGetPaymentProfile({ doc_id: docId, details: true });
    return (_jsxs(Segment, { className: "flex flex-col", children: [_jsx("h5", { children: "Payment Details" }), _jsx(PaymentProfile, { doctor: { doc_id: docId !== null && docId !== void 0 ? docId : "" }, loading: loading, error: error, profile: data === null || data === void 0 ? void 0 : data.profile, onSaved: refetch, editLabel: "Edit payment profile", updateLabel: "Update payment profile" })] }));
};
